export default function TabButton({
  isCountVisible,
  onTabClick,
  label,
  icon,
  active,
  count,
}: {
  isCountVisible?: boolean;
  onTabClick?: () => void;
  label: string;
  icon: React.ReactNode;
  active: boolean;
  count: number;
}) {
  return (
    <button
      type="button"
      onClick={onTabClick}
      aria-selected={active}
      className={`max-w flex flex-nowrap justify-center items-center flex-1 gap-x px-0.5x md:px-2x transition min-h-[48px] rounded-[40px] ${active ? 'bg-blue_light_2 ' : ''} `}
    >
      <div
        className={`flex items-center gap-0.5x flex-nowrap ${
          active ? ' text-blue text-link ' : 'text-gray__dark_2  text-body_2 '
        }`}
      >
        {icon}
        <p className="text-nowrap">{label}</p>
      </div>
      {isCountVisible && count > 0 && (
        <div className="flex w-[24px] h-[24px] items-center justify-center rounded-[50%] text-caption_2 bg-orange_light_1 text-orange_dark_2">
          {count}
        </div>
      )}
    </button>
  );
}
